import { useState } from 'react';
import { api, Deal, REQ_LABEL, Stage } from '../api';
import { ErrorBox, useAsync } from './ui';

/**
 * Lépésváltás. Elvesztett lépésnél bekéri az okot; ha a cél-lépésnek kötelező mezője hiányzik, a szerver 422-t ad,
 * és azt itt magyarázzuk el (a deal adatlapján pótolható).
 */
export function useMoveDeal(lostReasons: string[], onMoved: (d: Deal) => void) {
  const [pending, setPending] = useState<{ deal: Pick<Deal, 'id' | 'title'>; stage: Stage } | null>(null);
  const a = useAsync();
  const move = async (deal: Pick<Deal, 'id' | 'title' | 'stage_id'>, stage: Stage, lost_reason?: string) => {
    if (deal.stage_id === stage.id && !lost_reason) return;
    if (stage.kind === 'lost' && !lost_reason) { a.setError(null); setPending({ deal, stage }); return; }
    const r = await a.run(() => api<Deal>(`/deals/${deal.id}/stage`, { method: 'POST', body: { stage_id: stage.id, lost_reason } }));
    if (r) { setPending(null); onMoved(r); }
  };
  const dialog = pending ? <LostDialog title={pending.deal.title} reasons={lostReasons} busy={a.busy} error={a.error}
    onCancel={() => { setPending(null); a.setError(null); }} onOk={(reason) => move({ ...pending.deal, stage_id: '' }, pending.stage, reason)} /> : null;
  const error = !pending && a.error ? <ErrorBox error={a.error} /> : null;
  return { move, dialog, error, busy: a.busy };
}

function LostDialog({ title, reasons, onOk, onCancel, busy, error }: { title: string; reasons: string[]; onOk: (r: string) => void; onCancel: () => void; busy: boolean; error: unknown }) {
  const [r, setR] = useState('');
  const [other, setOther] = useState('');
  const value = r === 'Egyéb' ? (other.trim() ? `Egyéb: ${other.trim()}` : '') : r;
  return (
    <div className="modal-back" role="dialog" aria-modal="true" aria-label="Elvesztés oka" onClick={onCancel}>
      <div className="modal card" onClick={(e) => e.stopPropagation()}>
        <h3>Elvesztett: {title}</h3>
        <p className="muted">Miért veszett el? Az ok a riportokhoz és a későbbi javaslatokhoz kell.</p>
        <div className="reasons">
          {reasons.map((x) => <label key={x} className="check"><input type="radio" name="lost" checked={r === x} onChange={() => setR(x)} /> {x}</label>)}
        </div>
        {r === 'Egyéb' && <input autoFocus value={other} onChange={(e) => setOther(e.target.value)} placeholder="Röviden az ok…" maxLength={250} />}
        <ErrorBox error={error} />
        <div className="actions">
          <button className="danger" disabled={busy || !value} onClick={() => onOk(value)}>Elvesztettnek jelölöm</button>
          <button className="secondary" onClick={onCancel}>Mégse</button>
        </div>
      </div>
    </div>
  );
}

export const requiredHint = (s: Stage) => (s.required_fields.length ? `Kötelező: ${s.required_fields.map((f) => REQ_LABEL[f] ?? f).join(', ')}` : '');
